import { createClient, SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Supabase URL and Anon Key must be provided in environment variables.");
}

// Use a more robust singleton pattern with window-based storage
const GLOBAL_KEY = '__SOLERRO_SUPABASE_INSTANCE__';

function getSupabaseClient(): SupabaseClient {
  // Check for an existing instance in the global scope
  if (typeof window !== 'undefined') {
    const existingClient = (window as any)[GLOBAL_KEY];
    if (existingClient) {
      return existingClient;
    }
  }

  // Create new instance with production-optimized settings
  const client = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      storageKey: 'solerro-pm-auth',
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
      storage: typeof window !== 'undefined' ? window.localStorage : undefined
    },
    global: {
      headers: {
        'x-application-name': 'solerro-pm'
      }
    },
    // Add cache settings for better production performance
    db: {
      schema: 'public'
    },
    realtime: {
      params: {
        eventsPerSecond: 2
      }
    }
  });

  // Store in global scope
  if (typeof window !== 'undefined') {
    (window as any)[GLOBAL_KEY] = client;

    // Add error handling for token expiration
    client.auth.onAuthStateChange((event, session) => {
      if (event === 'TOKEN_REFRESHED') {
      } else if (event === 'SIGNED_OUT') {
        // Only store the return URL if we're not already on the login page
        const currentPath = window.location.pathname + window.location.search;
        if (currentPath !== '/login') {
          localStorage.setItem('returnTo', currentPath);
        }
        // Dispatch custom event for React Router navigation instead of hard refresh
        window.dispatchEvent(new CustomEvent('auth-signed-out'));
      }
    });
  }

  return client;
}

// Export the singleton instance
export const supabase = getSupabaseClient();
